import type { FC } from 'react';
import styles from './DeliveryRightPanel.module.css';
import type { DeliveryRightPanelProps } from './DeliveryRightPanel.types';

export const DeliveryRightPanel: FC<DeliveryRightPanelProps> = ({
  children,
  className = '',
}) => {
  return (
    <aside className={styles.panelRight + ' ' + className}>{children}</aside>
  );
};
